import React from 'react';
import { FaTiktok, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-5">
      <div className="container" data-aos="fade-up">
        <div className="row">
          <div className="col-md-4 mb-4">
            <h5 className="fw-bold mb-3">S.STATE</h5>
            <p className="text-white-50 small">
              وكالة إماراتية مصرية متخصصة في إدارة وتطوير صُنّاع المحتوى على منصة TikTok.
            </p>
            <div className="d-flex gap-3">
              <a href="https://www.tiktok.com/@s_state_0?_r=1&_t=ZS-93to7uyf67I" target="_blank" rel="noopener noreferrer" className="text-white-50 hover-warning">
                <FaTiktok size={24} />
              </a>
              <a href="#" className="text-white-50 hover-warning">
                <FaInstagram size={24} />
              </a>
              <a href="#" className="text-white-50 hover-warning">
                <FaTwitter size={24} />
              </a>
              <a href="#" className="text-white-50 hover-warning">
                <FaYoutube size={24} />
              </a>
            </div>
          </div>
          
          <div className="col-md-2 mb-4">
            <h6 className="fw-bold mb-3">روابط سريعة</h6>
            <ul className="list-unstyled">
              <li className="mb-2"><a href="#about" className="text-white-50 text-decoration-none small">من نحن</a></li>
              <li className="mb-2"><a href="#services" className="text-white-50 text-decoration-none small">خدماتنا</a></li>
              <li className="mb-2"><a href="#portfolio" className="text-white-50 text-decoration-none small">أعمالنا</a></li>
              <li className="mb-2"><a href="#contact" className="text-white-50 text-decoration-none small">اتصل بنا</a></li>
            </ul>
          </div>
          
          <div className="col-md-3 mb-4">
            <h6 className="fw-bold mb-3">خدماتنا</h6>
            <ul className="list-unstyled">
              <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none small">صانع المحتوى المتخصص</a></li>
              <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none small">حملات الانطلاق</a></li>
              <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none small">نظام اختبار الأداء</a></li>
              <li className="mb-2"><a href="#" className="text-white-50 text-decoration-none small">إنتاج محتوى</a></li>
            </ul>
          </div>
          
          <div className="col-md-3 mb-4">
            <h6 className="fw-bold mb-3">تواصل معنا</h6>
            <ul className="list-unstyled">
              <li className="mb-2 text-white-50 small">دبي - القاهرة</li>
              <li className="mb-2 text-white-50 small">info@s-state.agency</li>
              <li className="mb-2 text-white-50 small">+971 50 123 4567</li>
            </ul>
          </div>
        </div>
        
        <hr className="border-secondary" />
        
        <div className="row">
          <div className="col text-center">
            <p className="small text-white-50 mb-0">
              © {new Date().getFullYear()} S.STATE. جميع الحقوق محفوظة. وكالة إماراتية مصرية تابعة لسيف الدولة.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;